<template>
	<div class="dropdown info-item">
    <div class="dropdown__header" @click="toggleDropdown($event)" ref="dropTitle">
        <span class="info-item underline">개인정보처리방침</span>
        <i class="fa fa-angle-down" aria-hidden="true"></i>
        <i class="fa fa-angle-up" aria-hidden="true"></i>
    </div>
    <div class="dropdown__content">
      <ul>
          <li class="list">
            <span class="list" @click="push('privacy')">
              개인정보처리방침 시행일자: 2019.10.15
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV2')">
              개인정보처리방침 시행일자: 2020.02.01
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV4')">
              개인정보처리방침 시행일자: 2021.05.01
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV5')">
              개인정보처리방침 시행일자: 2021.10.12
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV6')">
              개인정보처리방침 시행일자: 2022.05.03
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV7')">
              개인정보처리방침 시행일자: 2023.03.17
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV8')">
              개인정보처리방침 시행일자: 2023.07.04
            </span>
          </li>
          <li class="list">
            <span @click="push('privacyV9')">
              개인정보처리방침 시행일자: 2025.01.02
            </span>
          </li>
      </ul>
    </div>
  </div>
</template>

<script>
import router from '@/router';

export default {
  methods: {
    toggleDropdown(event) {
      event.currentTarget.classList.toggle('is-active');
    },
    push(url) {
      router.push({ name: url });
      this.$refs.dropTitle.click();
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown {
  float: left;
  &__header {
    cursor: pointer;
    color: #222;
    font-weight: bold;
    // text-overflow: ellipsis;
    i.fa {
      position: absolute;
      transform: translateY(-50%);
      transition: opacity .3s;
      &.fa-angle-up {
        opacity: 0;
      }
    }
    &.is-active {
      i.fa {
        &.fa-angle-up {
            opacity: 1;
        }
        &.fa-angle-down {
            opacity: 0;
        }
      }
      +.dropdown__content {
        margin-top: 5px;
        position: absolute;
        height: auto;
        opacity: 1;
        visibility: visible;
        z-index:9999;
        background: white;
        box-shadow: 2px 2px 2px 2px gray;
        border-radius: 5px 5px 5px 5px / 5px 5px 5px 5px;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
  &__content {
    position: absolute;
    margin-top: 10px;
    padding-top: 7px;
    cursor: pointer;
    height: auto;
    opacity: 1;
    overflow: hidden;
    transition: opacity .3s;
    visibility: hidden;

    .list {
      font-weight: bold;
      margin-bottom: 7px;
			span:hover {
				background-color: lightgray;
			}
    }

  }
}

.underline {
  text-decoration: underline;
}

.bold {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/PrivacyList.vue